import { render } from "./WerehousePage.vue?vue&type=template&id=9b516b30&lang=html"
import script from "./WerehousePage.vue?vue&type=script&lang=js"
export * from "./WerehousePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__